module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_4.80618bee.png";